import { loadableReady } from '@loadable/component'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { BStockIntlProvider } from '@b-stock/fe-core/bstock-react'

import appConfig from '@config/config'
import { setupChunkLoadRecovery } from '@helpers/chunkLoadRecovery'
import presetStore from '@store/store'

import localeData from '../../locale/localeData'
import App from './App'
import { AuthProvider } from './AuthProvider'
import GoogleTagManager from './GoogleTagManager'

const { baseUrl } = appConfig

setupChunkLoadRecovery()

const rootElement = document.getElementById('app')
const root = createRoot(rootElement)

loadableReady(() =>
  root.render(
    <HelmetProvider>
      <Provider store={presetStore}>
        <BrowserRouter basename={baseUrl}>
          <GoogleTagManager />
          <BStockIntlProvider localeData={localeData}>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BStockIntlProvider>
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  )
)
